import Nullstack from 'nullstack';
export default function IconTools({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tools",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"
  }), "   ", Nullstack.element("line", {
    x1: "14.5",
    y1: "5.5",
    x2: "18.5",
    y2: "9.5"
  }), "   ", Nullstack.element("polyline", {
    points: "12 8 7 3 3 7 8 12"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "8",
    x2: "5.5",
    y2: "9.5"
  }), "   ", Nullstack.element("polyline", {
    points: "16 12 21 17 17 21 12 16"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "17",
    x2: "14.5",
    y2: "18.5"
  }), " ");
}